export default (hashStr: string): string => {
  return hashStr.substr(0, 5) + "..." + hashStr.substr(-5);
};
